<template>
	<div>
		<alert :visible="true" :unclosable="true"
			classes="alert-info"
			:classes="{
				'alert-info': jobNeedsQboMapping,
				'alert-light': !jobNeedsQboMapping
			}"
			:icon="jobNeedsQboMapping ? 'fa-unlink' : false">

			<span v-if="jobNeedsQboMapping">This {{jobTypeLabel}} is not linked to a project in Quickbooks. Select from the list below of projects from Quickbooks to link it to:</span>

			<!--
			<field :label="jobNeedsQboMapping ? 'Quickbooks Projects' : 'Mapped to QBO Project'"
				class="mt-2"
				col-class="col-auto"
				:params="{type:'select',options:unlinkedQboProjectsOptions}"
				v-model="qboProjectId"
				v-on:change="updateQboLink">
			</field>
			-->

			<field :label="jobNeedsQboMapping ? 'Quickbooks Jobs' : 'Mapped to QBO Job'"
				class="mt-2"
				col-class="col-auto"
				:params="{type:'select',options:unlinkedQboProjectsOptions}"
				:loading="qboSearchLoading"
				v-on:searchChange="qboJobSearchChange"
				v-model="qboJobId"
				v-on:change="updateQboLink">
				<small>Start typing to find your QBO job</small>
			</field>

		</alert>
	</div>
</template>
<script type="text/javascript">
import Alert from "@/components/Alert"
import Field from "@/components/Field"

export default {
	name: "QboJobSyncAlert",
	components: {
		Alert,
		Field
	},
	props: [
		'job',
		'apiResource',
		'value',
		'qboCustomerId'
	],
	data() {
		return {
			qboJobs: null,
			qboJobId: null,
			qboSearchLoading: false
		}
	},
	watch: {
		job() {
			this.fetchQboJobs()

			if ("qbo_id" in this.job)
				this.qboJobId = this.job.qbo_id
		}
	},
	computed: {
		jobTypeLabel() {
			return this.apiResource == 'Job' ? 'project' : 'service'
		},
		jobNeedsQboMapping() {
			if (!this.qboIsActive || this.job.qbo_id > 0)
				return false

			return true
		},
		unlinkedQboProjectsOptions() {
			if (!this.qboJobs)
				return []

			return this.qboJobs.map(customer => {
				return {
					value: customer.Id,
					text: customer.PrintOnCheckName
				}
			})
		}
	},
	methods: {
		updateQboLink(qboId) {
			let vm = this

			if (!qboId)
				qboId = 0

			this.postData(this.apiResource+"/save",{id:this.job.id,qbo_id: qboId},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Project successfully linked to Quickbooks")
					vm.$emit('qboIdSet',qboId)
				}
			})
		},
		qboJobSearchChange(searchTerms) {
			if (searchTerms) {
				this.debounce("searchQboJobs",searchTerms,1000)
				this.qboSearchLoading = true
			}
		},
		searchQboJobs(searchTerms) {
			let vm = this

			let payload = {
				resource: "Customer",
				where: "Job=true AND FullyQualifiedName LIKE '%" + searchTerms + "%'"
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("QuickbooksConnection/get-resource",payload).then(response => {
					if (response.success) 
						vm.qboJobs = response.data

					vm.qboSearchLoading = false
				
					resolve(response)
				})

			})
		},
		fetchQboJobs() {
			let vm = this

			let payload = {
				resource: "Customer",
				where: "Job=true AND Active=true"
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("QuickbooksConnection/get-resource",payload).then(response => {
					if (response.success) 
						vm.qboJobs = response.data
					
				
					resolve(response)
				})

			})
		},
	},
	created() {
		this.fetchQboJobs()

		if ("qbo_id" in this.job)
			this.qboJobId = this.job.qbo_id
	}
}
</script>